import {
  Action,
  createSelector,
  Selector,
  State,
  StateContext} from "@ngxs/store";
import { Comission } from "../model/comission.model";
import { inject, Injectable } from "@angular/core";
import {
  ClearComissions,
  LoadComissions,
  ReloadComissions} from "./comission.action";
import { ComissionService } from "../service/comission.service";
import { toComission } from "../mapper/comission.mapper";

export class ComissionStateModel {
  page: number;
  pageSize: number;
  total: number;
  pages: Record<number, Comission[]>;
  loading: boolean;
  error: Error | undefined;
}

@State<ComissionStateModel>({
  name: "comission",
  defaults: {
    page: 1,
    pageSize: 10,
    total: 0,
    pages: {},
    loading: true,
    error: undefined}})
@Injectable()
export class ComissionState {
  comissionService = inject(ComissionService);

  @Selector()
  static isLoading(state: ComissionStateModel) {
    return state.loading;
  }

  @Selector()
  static hasError(state: ComissionStateModel) {
    return !!state.error;
  }

  @Selector()
  static currentPageData(state: ComissionStateModel) {
    return state.pages[state.page] || [];
  }

  static pageData(page: number) {
    return createSelector(
      [ComissionState],
      (state: ComissionStateModel) => state.pages[page] || [],
    );
  }

  @Selector()
  static pagination(state: ComissionStateModel) {
    return {
      page: state.page,
      pageSize: state.pageSize,
      total: state.total,
      totalPages: Math.ceil(state.total / state.pageSize) || 0};
  }

  @Action(LoadComissions)
  async loadComissions(
    ctx: StateContext<ComissionStateModel>,
    action: LoadComissions,
  ) {
    const state = ctx.getState();
    const nextPage = action.page ?? state.page;
    const nextPageSize = action.pageSize ?? state.pageSize;
    const key = nextPage;

    console.info(state.pages[nextPage]);
    if (state.pages[nextPage]) {
      ctx.patchState({
        page: nextPage,
        pageSize: nextPageSize,
        loading: false,
        error: undefined});
      return;
    }

    ctx.patchState({
      loading: true,
      page: nextPage,
      pageSize: nextPageSize,
      error: undefined});

    try {
      const response = await this.comissionService.getComissions(
        nextPage,
        nextPageSize,
      );

      const comissions = toComission(response); // ajuste se retorna objeto
      const total = response.pagination.total;

      // Usa getState de novo para evitar sobrescrever pages em corrida
      const current = ctx.getState();
      ctx.patchState({
        loading: false,
        total,
        pages: {
          ...current.pages,
          [key]: comissions}});
    } catch (error) {
      console.error("Erro ao carregar comissions", error);
      ctx.patchState({
        loading: false,
        error: error as Error});
    }
  }

  @Action(ReloadComissions)
  reloadComissions(ctx: StateContext<ComissionStateModel>) {
    ctx.patchState({
      page: 1,
      total: 0,
      pages: {},
      loading: true,
      error: undefined});
    return ctx.dispatch(new LoadComissions(1, 10));
  }

  @Action(ClearComissions)
  clearComissions(ctx: StateContext<ComissionStateModel>) {
    ctx.patchState({
      page: 1,
      pageSize: 10,
      total: 0,
      pages: {},
      loading: true,
      error: undefined});
  }
}
